/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Oid from './Oid';

/**
 * The X509Extension model module.
 * @module model/X509Extension
 * @version V1
 */
class X509Extension {
    /**
     * Constructs a new <code>X509Extension</code>.
     * @alias module:model/X509Extension
     */
    constructor() { 
        
        X509Extension.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>X509Extension</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/X509Extension} obj Optional instance to populate.
     * @return {module:model/X509Extension} The populated <code>X509Extension</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new X509Extension();

            if (data.hasOwnProperty('critical')) {
                obj['critical'] = ApiClient.convertToType(data['critical'], 'Boolean');
            }
            if (data.hasOwnProperty('oid')) {
                obj['oid'] = Oid.constructFromObject(data['oid']);
            }
            if (data.hasOwnProperty('rawData')) {
                obj['rawData'] = ApiClient.convertToType(data['rawData'], 'Blob');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>X509Extension</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>X509Extension</code>.
     */
    static validateJSON(data) {
        // validate the optional field `oid`
        if (data['oid']) { // data not null
          Oid.validateJSON(data['oid']);
        }

        return true;
    }


}



/**
 * @member {Boolean} critical
 */
X509Extension.prototype['critical'] = undefined;

/**
 * @member {module:model/Oid} oid
 */
X509Extension.prototype['oid'] = undefined;

/**
 * @member {Blob} rawData
 */
X509Extension.prototype['rawData'] = undefined;






export default X509Extension;

